import StoreUtil from '@app/store/StoreUtil';
import { PERSIST_SUFFIX } from '@app/store/persistence/statePersist';

// todo add comment why do we have decorateMutationType with sufix
export const SET_RANDOM_NUMBERS_AMOUNT =  StoreUtil.decorateMutationType(
    'SET_RANDOM_NUMBERS_AMOUNT',
    [PERSIST_SUFFIX]
);
// todo suggestion, what do you think is it better to have set_are_favourites_saving?  set+stateName, we can discuss
export const SET_FAVOURITES_SAVING = 'SET_FAVOURITES_SAVING';

export const SET_FAVOURITE = 'SET_FAVOURITE';
export const DELETE_FAVOURITE = 'DELETE_FAVOURITE';
export const SET_FAVOURITES = 'SET_FAVOURITES';
export const SET_SELECTED_FAVOURITES = 'SET_SELECTED_FAVOURITES';
export const SET_ARE_FAVOURITES_FETCHED_UPON_LOGIN = 'SET_ARE_FAVOURITES_FETCHED_UPON_LOGIN';
export const UPDATE_TIMESTAMP = 'UPDATE_TIMESTAMP';
export const SET_SELECTED_SIDEBAR_COMPONENT = 'SET_SELECTED_SIDEBAR_COMPONENT';
export const SET_IS_LOADING = 'SET_IS_LOADING';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/lotto/mutationTypes.ts